import { render, staticRenderFns } from "./QuizScoreCard.vue?vue&type=template&id=5abb3a28&scoped=true&"
import script from "./QuizScoreCard.vue?vue&type=script&lang=js&"
export * from "./QuizScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./QuizScoreCard.vue?vue&type=style&index=0&id=5abb3a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb3a28",
  null
  
)

export default component.exports